import React from "react";
import { CardContent, Typography, Grid } from "@mui/material";
import SvgIcon from "./SvgIcon";
import { StyleCard, StyleHeading, StyleTypography } from "../assets/js/Theme";
import { commaSeparateFormat, dateFormat } from "../resources/utils";
import { injectIntl } from "react-intl";
function CardTheme1(props) {
  const { intl, data, name, labels } = props;
  return (
    <StyleCard variant="outlined" className={`card--wrapper-design-1 ${name}`}>
      <CardContent>
        <StyleTypography color="primary" variant="body1" gutterBottom>
          <StyleTypography color="primary" component="strong">
            {`${labels.date}: `}
          </StyleTypography>
          {data && dateFormat(data.evidence_date)}
        </StyleTypography>
        <StyleHeading color="error" variant="h3">
          <StyleTypography color="primary" component="strong">
            {`${labels.price}: `}
            <StyleTypography color="error" component="strong">
              {`${intl.formatMessage({
                id: "GENERAL.AED",
              })} `}
            </StyleTypography>
          </StyleTypography>
          {data &&
            data.total_sales_price &&
            commaSeparateFormat(data.total_sales_price)}
        </StyleHeading>

        <Typography
          color="primary"
          variant="h6"
          className="property--address font-weight-400"
        >
          {data && data.search_value && data.search_value}
        </Typography>

        <hr />

        <Grid
          container
          className="property--info--wrapper"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Grid item xs={'auto'} className="property--info">
            <Typography className="property--icon" component="span">
              <SvgIcon name="type" colorStyle="comparable--icon" />
            </Typography>
            <StyleTypography className="property--text">
              {data.unit_type}
            </StyleTypography>
          </Grid>
          <Grid item xs={7} className="property--info">
            <Typography className="property--icon" component="span">
              <SvgIcon name="bedroom" colorStyle="comparable--icon" />
            </Typography>
            <StyleTypography className="property--text">
              {`${data.no_beds_label}`}
            </StyleTypography>
          </Grid>
          <Grid item xs={'auto'} className="property--info unit--size">
            <Typography className="property--icon" component="span">
              <SvgIcon name="size" colorStyle="comparable--icon" />
            </Typography>
            <StyleTypography className="property--text">
              {`${commaSeparateFormat(data.unit_size_sqft)} (${labels.unit}) ${labels.sqFt
                }`}
            </StyleTypography>
          </Grid>
          {data.floor_level ? (
            <Grid item xs={'auto'} className="property--info">
              <Typography className="property--icon" component="span">
                <SvgIcon name="floor" colorStyle="comparable--icon" />
              </Typography>
              <StyleTypography className="property--text">
                {`${data.floor_level} ${labels.floor}`}
              </StyleTypography>
            </Grid>
          ) : null}
          {data.plot_size_sqft ? (
            <Grid item xs={"auto"} className="property--info unit--size">
              <Typography className="property--icon" component="span">
                <SvgIcon name="size" colorStyle="comparable--icon" />
              </Typography>
              <StyleTypography className="property--text">
                {`${commaSeparateFormat(data.plot_size_sqft)} (${labels.plot
                  }) ${labels.sqFt}`}
              </StyleTypography>
            </Grid>
          ) : null}

        </Grid>
      </CardContent>
    </StyleCard>
  );
}

export default injectIntl(CardTheme1);
